export const BUILD_VERSION = '1777667681';
